import React from "react";
import {Link} from "react-router-dom";
import TestimonialC from "../components/TestimonialC";
import FacilitiesC from "../components/FacilitiesC";
const About = () => {
  return (
      <main>
        <section className="blog-banner-area" id="about">
          <div className="container h-100">
            <div className="blog-banner">
              <div className="text-center">
                <h1>About Us</h1>
                <nav aria-label="breadcrumb" className="banner-breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link className="" to={"/"}>Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">About us</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </section>

        <section className="welcome pt-0 section-margin">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-5 mb-4 mb-lg-0">
                <div className="row no-gutters welcome-images">
                  <div className="col-sm-7">
                    <div className="card">
                      <img className="" src="img/home/welcomeBanner1.png" alt="Card image cap" />
                    </div>
                  </div>
                  <div className="col-sm-5">
                    <div className="card">
                      <img className="" src="img/home/welcomeBanner2.png" alt="Card image cap" />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="card">
                      <img className="" src="img/home/welcomeBanner3.png" alt="Card image cap" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="welcome-content">
                  <h2 className="mb-4"><span className="d-block">Welcome</span> to our residence</h2>
                  <p>Beginning blessed second a creepeth. Darkness wherein fish years good air whose after seed appear midst evenin, appear void give third bearing divide one so blessed moved firmament gathered </p>
                  <p>Beginning blessed second a creepeth. Darkness wherein fish years good air whose after seed appear midst evenin, appear void give third bearing divide one so blessed</p>
                  <a className="button button--active home-banner-btn mt-4" href="#">Learn More</a>
                </div>
              </div>
            </div>
          </div>
        </section>

    

        <section className="section-padding bg-porcelain">
          <div className="container">
            <div className="section-intro text-center pb-80px">
              <div className="section-intro__style">
                <img src="img/home/bed-icon.png" alt="" />
              </div>
              <h2>Special Facilities</h2>
            </div>
            <div className="special-img mb-30px">
              <img className="img-fluid" src="img/home/special.png" alt="" />
            </div>

            <FacilitiesC />
          </div>
        </section>

        <section className="section-margin">
          <div className="container">
            <div className="section-intro text-center pb-20px">
              <div className="section-intro__style">
                <img src="img/home/bed-icon.png" alt="" />
              </div>
              <h2>Our Guest Love Us</h2>
            </div>

            <TestimonialC />
          </div>
        </section>
      </main>
);
};

export default About;